export function convertDateFormatShortYear(dateStr) {
  // Split the input string into parts: [day, month, year]
  const parts = dateStr.split('-');
  
  // Check if we have exactly 3 parts
  if (parts.length !== 3) {
    throw new Error('Invalid date format. Expected DD-MM-YYYY');
  }
  
  let [day, month, year] = parts;

  
  // Return the date in MM-DD-YY format
  return `${month}-${day}-${year}`;
}